import styled from 'styled-components/macro';

export const MenuFooter = styled.footer`
  height: 50px;
  width: 100%;
  position: fixed;
  text-align: center;
  bottom: 0;
  padding: 0.8rem 2rem;
  font-size: 10px;
  letter-spacing: 0.04rem;

  .home-content__line {
    display: block;
    width: 1px;
    height: 12rem;
    background-color: #ec008c;
    position: absolute;
    right: 84px;
    bottom: 0;
  }
`;
